import r from "styled-components";
import { breakpoints as t } from "./atoms-v2125.js";
import { INPUT_PRODUCTIVE_HEIGHT_SMALL as a, INPUT_PRODUCTIVE_HEIGHT as s } from "./atoms-v2810.js";
import { Input as d } from "./atoms-v2777.js";
import { InputLabel as l } from "./atoms-v2129.js";
import { SkeletonRow as p } from "./atoms-v2778.js";
import { getColor as u } from "./atoms-v2815.js";
const b = r.input`
  ${d}

  ${({ theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get("tokens.body.compact-productive")) == null ? void 0 : n.toJS();
}}

  appearance: textfield;
  background-color: transparent;
  color: ${({ $colorTheme: o = "light", disabled: n, theme: i }) => u({ colorTheme: o, disabled: n, theme: i })};
  flex-grow: 1;
  height: ${a}px;
  min-width: 0;

  /* Offset the value to make room for the floating label. This custom prop is assigned in the
  InputContainer component. */
  padding-left: 14px;
  padding-right: var(--padding-x);
  padding-top: 18px;
  width: 100%;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    /* 
      Chrome autofill background hack:
      WebKit animates a yellow/blue background-color on autofill.
      This forces that animation to take ~9999s, so the autofill
      paint never visibly appears. Input keeps our custom styles.
    */
    transition:
      background-color 9999s ease-out,
      color 9999s ease-out;
  }

  @media ${t.medium} {
    ${({ theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get("tokens.body.compact-expressive")) == null ? void 0 : n.toJS();
}}
    height: ${s}px;
  }
`, I = r(l)`
  --padding-x: 14px;
`, v = r.div`
  align-items: center;
  color: ${({ $colorTheme: o = "light", $isErrored: n, theme: i }) => n ? i == null ? void 0 : i.get(`tokens.text.${o}.error`) : "inherit"};
  column-gap: 12px;
  display: flex;
  padding-right: var(--padding-x);
`, y = r(p)`
  column-gap: 1px;
  display: flex;
  height: ${a}px;
  justify-content: end;

  @media ${t.medium} {
    height: ${s}px;
  }
`, w = r.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-template-rows: 1fr;
`;
r.select`
  appearance: none;
  background-color: transparent;
  border: none;
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusSm")}px;
  color: transparent;
  cursor: ${({ disabled: o }) => o ? "auto" : "pointer"};
  grid-area: 1 / 1 / 2 / 2;
  outline: 1px solid transparent;
  outline-offset: -1px;
  transition: outline ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("duration.fast")}
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.motion").toString("easing.standard")};
  width: 100%;

  &:focus-visible {
    outline-color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.colors.focus.focus")};
  }

  @media ${t.medium} {
    border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusMed")}px;
  }
`;
const S = r.div`
  align-items: center;
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusMed")}px;
  color: ${({ $colorTheme: o = "light", $isDisabled: n, theme: i }) => n ? i == null ? void 0 : i.get(`tokens.text.${o}.disabled`) : i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};
  column-gap: 8px;
  display: flex;
  grid-area: 1 / 1 / 2 / 2;
  outline: 1px solid transparent;
  padding: 0 10px 0 18px;
  pointer-events: none;

  ${({ $colorTheme: o = "light", $isFocused: n, theme: i }) => n && `
    outline-color: ${i == null ? void 0 : i.get(`ui.field.${o}.borderHover`)};
  `}
`, T = r.div`
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.fieldRadiusMed")}px;
  display: flex;
  outline: 1px solid transparent;
  position: relative;

  ${({ $colorTheme: o = "light", $isFocused: n, theme: i }) => n && `
    outline-color: ${i == null ? void 0 : i.get(`ui.field.${o}.borderHover`)};
  `}
`;
export {
  S as Country,
  v as Icons,
  b as Input,
  T as PhoneInputContainer,
  w as PhoneInputInterior,
  I as PhoneInputLabel,
  y as SkeletonInput
};
